<template>
    <div>
        <v-card class="px-4">
            <v-card-title class="headline pl-0 mb-2">New Payment</v-card-title>
            <div v-if="!showConfirmView">
                <v-layout align-center justify-center>
                    <v-card-actions>
                        <v-btn-toggle
                            mandatory
                            v-model="paymentMode"
                            class="mb-2 elevation-0 button-toggle-override"
                            @change="generateSchedules()"
                        >
                            <v-btn flat value="single" class="big-button">
                                Single Payment
                            </v-btn>
                            <v-divider
                                vertical
                                style="border-color: #9e9e9e"
                            ></v-divider>
                            <v-btn flat value="schedule" class="big-button">
                                Schedule
                            </v-btn>
                        </v-btn-toggle>
                    </v-card-actions> </v-layout
                ><v-card-actions
                    class="mx-0 mb-3"
                    v-bind:class="{ 'mb-0 pb-0': paymentMode == 'schedule' }"
                >
                    <v-select
                        class="ml-1"
                        style="max-width: 36%;"
                        :items="paymentMethods.map((p) => p.cardInfo)"
                        v-model="selectedCard"
                        label="Payment Method"
                        hide-details
                    ></v-select>
                    <v-btn
                        @click="newPaymentMethodDialog = true"
                        small
                        outline
                        class="ml-3 mb-1"
                        color="success"
                        >New Payment Method</v-btn
                    >
                </v-card-actions>

                <v-checkbox
                    v-model="dontAuthorize"
                    label="Don't Authorize Card"
                    hide-details
                    class="mt-0 mb-3"
                    color="success"
                    v-if="paymentMode == 'schedule'"
                ></v-checkbox>
                <v-layout column class="mx-0 mb-0">
                    <v-text-field
                        box
                        v-model="tuitionAmount"
                        label="Tuition"
                        type="number"
                        prefix="$"
                        ref="tuitionAmount"
                        @input="generateSchedules()"
                        :rules="[amountRules.required, amountRules.min]"
                    ></v-text-field>
                    <!-- <v-text-field
                        box
                        v-model="transportationAmount"
                        label="Transportation"
                        type="number"
                        prefix="$"
                        ref="transportationAmount"
                        @input="generateSchedules()"
                        :rules="[amountRules.required, amountRules.min]"
                    ></v-text-field> -->
                </v-layout>

                <div v-if="paymentMode == 'schedule'">
                    <v-divider class="mb-4"></v-divider>
                    <v-text-field
                        type="number"
                        label="Number Of Payments"
                        class=""
                        ref="numberOfPayments"
                        v-model="numberOfPayments"
                        @input="generateSchedules()"
                        :rules="numberOfPaymentsRules"
                    ></v-text-field>
                    <v-btn-toggle
                        mandatory
                        v-model="scheduleMode"
                        class="mb-2"
                        @change="generateSchedules()"
                        v-if="!showCalendarDays"
                    >
                        <v-btn value="month">
                            Month
                        </v-btn>
                        <v-btn value="week">
                            Week
                        </v-btn>
                    </v-btn-toggle>
                    <v-layout row>
                        <v-menu
                            v-model="datePickerMenu"
                            :close-on-content-click="true"
                            offset-y
                            full-width
                            prepend-icon="mdi-currency-usd"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="startDate"
                                    label="Start Date"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="startDate"
                                :min="today"
                                @change="generateSchedules()"
                            ></v-date-picker>
                        </v-menu>
                        <v-switch
                            v-model="showCalendarDays"
                            color="success"
                            class="ml-3"
                            label="Schedule By Day Of Month"
                            @change="generateSchedules"
                        ></v-switch>
                    </v-layout>

                    <v-layout row v-if="showCalendarDays">
                        <v-btn-toggle
                            mandatory
                            v-model="calendarMode"
                            class="toggle-button-group mt-2 mr-2"
                            style="height: 30px;"
                            @change="calendarModeChanged"
                        >
                            <v-btn flat value="hebrew" class="toggle-button">
                                Hebrew
                            </v-btn>
                            <v-btn flat value="english" class="toggle-button">
                                English
                            </v-btn>
                        </v-btn-toggle>

                        <v-select
                            v-if="calendarMode == 'hebrew'"
                            class="ml-3"
                            :items="
                                calendarDays
                                    .filter((c) => c.HEBREW)
                                    .map((c) => c.HEBREW)
                            "
                            label="PREFERRED DAY IN MONTH"
                            v-model="dayInMonth"
                            @change="generateSchedules"
                        ></v-select>
                        <v-select
                            v-if="calendarMode == 'english'"
                            class="ml-3"
                            :items="calendarDays.map((c) => c.value)"
                            label="PREFERRED DAY IN MONTH"
                            v-model="dayInMonth"
                            @change="generateSchedules"
                        ></v-select>
                    </v-layout>

                    <v-layout row v-for="schedule in schedules">
                        <v-text-field
                            class="mr-2"
                            v-model="schedule.tuitionAmount"
                            label="Tuition"
                            type="number"
                            prefix="$"
                            ref="scheduleTuitionAmount"
                        ></v-text-field>
                        <v-menu
                            v-model="schedule.datePickerMenu"
                            :close-on-content-click="true"
                            offset-y
                            full-width
                            prepend-icon="mdi-currency-usd"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="schedule.date"
                                    label="Date"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="schedule.date"
                                :min="today"
                            ></v-date-picker>
                        </v-menu>
                        <div class="pt-3" v-if="schedule.hebrewDate">
                            {{ schedule.hebrewDate }}
                        </div>
                    </v-layout>
                    <v-divider class="mt-2 mb-4"></v-divider>
                </div>

                <v-text-field
                    class="mb-2"
                    v-model="emailAddress"
                    label="Email Address"
                    :rules="emailRules"
                    ref="emailAddress"
                ></v-text-field>
                <v-text-field
                    label="Note"
                    class=""
                    v-model="note"
                ></v-text-field>
                <v-card-actions class="mx-0 pb-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        class="mr-1"
                        @click="closeDialog()"
                        >Cancel</v-btn
                    >
                    <v-btn color="success" @click="confirmPayment()">
                        Continue
                    </v-btn>
                </v-card-actions>
            </div>

            <div v-if="showConfirmView">
                <div v-if="!paymentProcessed && !scheduleProcessed">
                    <div v-if="paymentMode == 'single'">
                        <div class="headline text-warning text-xs-center mb-4">
                            Please confirm the details below
                        </div>
                        <div
                            style="border: #4caf50 3px solid"
                            class="px-3 pt-3"
                        >
                            <v-layout row class="mb-2">
                                <div class="font-weight-medium width-200">
                                    Payment Method
                                </div>
                                <div>
                                    {{ selectedCard }}
                                </div>
                            </v-layout>
                            <v-layout row class="mb-2">
                                <div
                                    class="font-weight-medium width-200"
                                    v-if="emailAddress"
                                >
                                    Email Address:
                                </div>
                                <div>
                                    {{ emailAddress }}
                                </div>
                            </v-layout>
                            <v-layout row class="mb-2">
                                <div
                                    class="font-weight-medium width-200"
                                    v-if="note"
                                >
                                    Note:
                                </div>
                                <div>
                                    {{ note }}
                                </div>
                            </v-layout>
                        </div>
                        <v-divider></v-divider>
                        <div class="font-weight-medium title my-3">Payment</div>
                        <v-data-table
                            :headers="getPaymentConfirmationHeaders()"
                            :items="getPaymentConfirmationDetails()"
                            class="elevation-2 my-3"
                            disable-sort
                            :mobile-breakpoint="NaN"
                            hide-actions
                        >
                            <template v-slot:items="props">
                                <td>{{ props.item.category }}</td>
                                <td class="text-xs-right">
                                    {{ props.item.amount }}
                                </td>
                            </template>
                        </v-data-table>
                    </div>
                    <div v-else>
                        <div class="headline text-warning text-xs-center mb-4">
                            Please confirm the details below
                        </div>
                        <div
                            style="border: #4caf50 3px solid"
                            class="px-3 pt-3"
                        >
                            <v-layout row class="mb-2">
                                <div class="font-weight-medium width-200">
                                    Payment Method
                                </div>
                                <div>
                                    {{ selectedCard }}
                                </div>
                            </v-layout>
                            <v-layout row class="mb-2">
                                <div
                                    class="font-weight-medium width-200"
                                    v-if="emailAddress"
                                >
                                    Email Address:
                                </div>
                                <div>
                                    {{ emailAddress }}
                                </div>
                            </v-layout>
                            <v-layout row class="mb-2">
                                <div
                                    class="font-weight-medium width-200"
                                    v-if="note"
                                >
                                    Note:
                                </div>
                                <div>
                                    {{ note }}
                                </div>
                            </v-layout>
                        </div>
                        <v-divider class="pb-3 mt-3"></v-divider>
                        <div v-if="getCurrentAmount()">
                            <div class="font-weight-medium title mb-3">
                                Payment
                            </div>
                            <v-data-table
                                :headers="getPaymentConfirmationHeaders()"
                                :items="getPaymentConfirmationDetails()"
                                class="elevation-2 my-3"
                                disable-sort
                                :mobile-breakpoint="NaN"
                                hide-actions
                            >
                                <template v-slot:items="props">
                                    <td>{{ props.item.category }}</td>
                                    <td class="text-xs-right">
                                        {{ props.item.amount }}
                                    </td>
                                </template>
                            </v-data-table>
                        </div>
                        <div v-if="hasScheduledPayments()">
                            <div class="font-weight-medium title mb-3">
                                Schedule
                            </div>
                            <v-data-table
                                :headers="getScheduleConfirmationHeaders()"
                                :items="getScheduleConfirmationDetails()"
                                class="elevation-2 my-3"
                                disable-sort
                                :mobile-breakpoint="NaN"
                                hide-actions
                            >
                                <template v-slot:items="props">
                                    <td class="text-xs-left">
                                        {{ props.item.date }}
                                    </td>
                                    <td class="text-xs-center">
                                        {{ props.item.tuition }}
                                    </td>
                                    <!-- <td class="text-xs-right">
                                        {{ props.item.transportation }}
                                    </td> -->
                                </template>
                            </v-data-table>
                        </div>
                    </div>

                    <v-card-actions class="mx-0 pb-3 mt-4">
                        <div style="color: #4caf50">
                            {{ processingMessage }}
                        </div>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="default"
                            dark
                            class="mr-1"
                            @click="closeDialog()"
                            >Cancel</v-btn
                        >
                        <v-btn
                            color="default"
                            dark
                            class="mr-1"
                            @click="showConfirmView = false"
                            >Back</v-btn
                        >
                        <v-btn
                            color="success"
                            :loading="processing"
                            @click="process()"
                        >
                            Confirm
                        </v-btn>
                    </v-card-actions>
                </div>

                <div v-if="paymentProcessed || scheduleProcessed">
                    <div v-if="+getCurrentAmount() > 0" class="px-3">
                        <div v-if="paymentStatus == 'A'">
                            <v-layout justify-center>
                                <v-icon
                                    style="height: 100px;"
                                    size="100"
                                    color="#A5DC86"
                                    class="mt-2"
                                    >mdi-check-circle-outline</v-icon
                                >
                            </v-layout>
                            <v-layout justify-center>
                                <v-card-title
                                    style="color: #4caf50"
                                    class="font-weight-medium title"
                                    >Payment Approved</v-card-title
                                >
                            </v-layout>
                        </div>
                        <div v-if="paymentStatus == 'D'">
                            <v-layout justify-center>
                                <v-icon
                                    style="height: 100px;"
                                    size="100"
                                    class="mt-2"
                                    color="rgb(243, 81, 35)"
                                    >mdi-alert</v-icon
                                >
                            </v-layout>
                            <v-layout justify-center>
                                <v-card-title
                                    class="font-weight-medium title text-danger mb-2"
                                    >Payment Declined</v-card-title
                                >
                            </v-layout>
                            <v-layout justify-center>
                                <div class="text-danger mb-2">
                                    {{ paymentResult }}
                                </div>
                            </v-layout>
                            <v-card-actions class="mb-2">
                                <v-spacer></v-spacer>
                                <v-btn
                                    small
                                    color="success"
                                    @click="
                                        processingMessage = '';
                                        paymentProcessed = false;
                                        scheduleProcessed = false;
                                        showConfirmView = false;
                                    "
                                    >Try Again</v-btn
                                ><v-spacer></v-spacer>
                            </v-card-actions>
                        </div>
                        <div v-if="paymentStatus == 'E'">
                            <v-layout justify-center>
                                <v-icon
                                    style="height: 100px;"
                                    size="100"
                                    class="mt-2"
                                    color="rgb(243, 81, 35)"
                                    >mdi-alert-circle</v-icon
                                >
                            </v-layout>
                            <v-layout justify-center>
                                <v-card-title class="font-weight-medium title"
                                    >An Error Occurred</v-card-title
                                >
                            </v-layout>
                            <v-layout justify-center>
                                <div class="text-danger text-xs-center">
                                    {{ paymentResult }}
                                </div>
                            </v-layout>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    color="success"
                                    small
                                    @click="
                                        processingMessage = '';
                                        paymentProcessed = false;
                                        scheduleProcessed = false;
                                        showConfirmView = false;
                                    "
                                    >Try Again</v-btn
                                ><v-spacer></v-spacer>
                            </v-card-actions>
                        </div>
                    </div>
                    <div v-if="hasScheduledPayments() && scheduleProcessed">
                        <v-divider
                            class="mb-3"
                            v-if="+getCurrentAmount() > 0"
                        ></v-divider>
                        <div v-if="!scheduleError">
                            <v-layout justify-center>
                                <v-icon
                                    style="height: 100px;"
                                    size="100"
                                    color="#A5DC86"
                                    class="mt-2"
                                    >mdi-check-circle-outline</v-icon
                                >
                            </v-layout>
                            <v-layout justify-center>
                                <v-card-title
                                    style="color: #4caf50"
                                    class="font-weight-medium title"
                                    >Payments Scheduled</v-card-title
                                >
                            </v-layout>
                            <v-divider class="mb-3"></v-divider>
                            <v-layout row class="my-3">
                                <div class="font-weight-medium">DATE</div>
                                <v-spacer style="width: 22%;"></v-spacer>
                                <div class="font-weight-medium">TUITION</div>
                                <!-- <div class="font-weight-medium">
                                    TRANSPORTATION
                                </div> -->
                            </v-layout>
                            <v-divider class="mb-3"></v-divider>
                            <div
                                v-for="(schedule,
                                index) in getSchedulePayments()"
                            >
                                <v-layout row class="my-3">
                                    <div>{{ schedule.date | date }}</div>
                                    <v-spacer></v-spacer>
                                    <div>
                                        {{ schedule.tuitionAmount | currency }}
                                    </div>
                                    <!-- <div>
                                        {{
                                            schedule.transportationAmount
                                                | currency
                                        }}
                                    </div> -->
                                </v-layout>
                                <v-divider
                                    v-if="
                                        index + 1 < getSchedulePayments().length
                                    "
                                    :key="index"
                                ></v-divider>
                            </div>
                        </div>
                        <div v-if="scheduleError">
                            <v-layout justify-center>
                                <v-icon
                                    style="height: 100px;"
                                    size="100"
                                    class="mt-2"
                                    color="rgb(243, 81, 35)"
                                    >mdi-alert-circle</v-icon
                                >
                            </v-layout>
                            <v-layout justify-center>
                                <v-card-title class="font-weight-medium title"
                                    >An error occurred while setting up the
                                    schedule</v-card-title
                                >
                            </v-layout>
                            <div class="text-danger text-xs-center">
                                {{ scheduleError }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <v-card-actions
                class="mr-0 pb-3"
                v-if="paymentProcessed || scheduleProcessed"
            >
                <v-spacer></v-spacer>
                <v-btn
                    color="success"
                    @click="
                        closeDialog();
                        reset();
                        reloadPage();
                    "
                    >Close</v-btn
                >
            </v-card-actions>
        </v-card>
        <v-dialog v-model="newPaymentMethodDialog" max-width="400">
            <new-payment-method
                :accountID="account.accountID"
                :closeDialog="closeNewPaymentMethodDialog"
                :onSave="updateSelectedPaymentMethod"
            ></new-payment-method>
        </v-dialog>
    </div>
</template>

<script>
import moment from "moment";
import {
    formatCurrency,
    sum,
    toISOLocal,
    onlyUnique,
} from "../../utils/helpers.js";
import newPaymentMethod from "../Payment/NewPaymentMethod.vue";
import * as Hebcal from "hebcal";

export default {
    props: {
        closeDialog: Function,
        account: Object,
        paymentMethods: Array,
        reloadPage: Function,
        tuitionBalance: String,
        transportationBalance: String,
    },
    components: {
        newPaymentMethod,
    },
    data() {
        return {
            paymentMode: "single",
            scheduleMode: "month",
            showConfirmView: false,
            processing: false,

            confirmDialog: false,
            newPaymentMethodDialog: false,
            numberOfPayments: "1",

            processingMessage: "",

            tuitionAmount: 0,
            transportationAmount: 0,

            emailAddress: "",
            note: "",
            today: moment().format("YYYY-MM-DD HH:mm:ss"),
            datePickerMenu: false,

            schedules: [],

            startDate: toISOLocal(new Date(moment())).substr(0, 10),

            selectedCard: "",

            paymentProcessed: false,
            scheduleProcessed: false,
            paymentStatus: "",
            paymentResult: "",
            scheduleError: "",
            dayInMonth: "",
            showCalendarDays: false,
            calendarMode: "hebrew",

            dontAuthorize: false,

            calendarDays: [
                { value: 1, HEBREW: "א" },
                { value: 2, HEBREW: "ב" },
                { value: 3, HEBREW: "ג" },
                { value: 4, HEBREW: "ד" },
                { value: 5, HEBREW: "ה" },
                { value: 6, HEBREW: "ו" },
                { value: 7, HEBREW: "ז" },
                { value: 8, HEBREW: "ח" },
                { value: 9, HEBREW: "ט" },
                { value: 10, HEBREW: "י" },
                { value: 11, HEBREW: "יא" },
                { value: 12, HEBREW: "יב" },
                { value: 13, HEBREW: "יג" },
                { value: 14, HEBREW: "יד" },
                { value: 15, HEBREW: "טו" },
                { value: 16, HEBREW: "טז" },
                { value: 17, HEBREW: "יז" },
                { value: 18, HEBREW: "יח" },
                { value: 19, HEBREW: "יט" },
                { value: 20, HEBREW: "כ" },
                { value: 21, HEBREW: "כא" },
                { value: 22, HEBREW: "כב" },
                { value: 23, HEBREW: "כג" },
                { value: 24, HEBREW: "כד" },
                { value: 25, HEBREW: "כה" },
                { value: 26, HEBREW: "כו" },
                { value: 27, HEBREW: "כז" },
                { value: 28, HEBREW: "כח" },
                { value: 29, HEBREW: "כט" },
                { value: 30, HEBREW: "ל" },
                { value: 31 },
            ],

            categories: new Map([
                ["TC", "Tuition"],
                ["TRNS", "Transportation"],
                ["LAPC", "Lapidus"],
                ["DDIN", "Dinner"],
            ]),

            today: new Date().toISOString().substr(0, 10),

            reasonRules: [(value) => !!value || "Reason Is Required"],
            numberOfPaymentsRules: [
                (value) =>
                    !!value ||
                    this.paymentMode == "single" ||
                    "Number Of Payments Is Required",
                (value) => !value || value > 0 || "minimum 1 schedule required",
            ],

            amountRules: {
                required: (value) =>
                    value > 0 ||
                    +this.tuitionAmount > 0 ||
                    +this.transportationAmount > 0 ||
                    "Amount is Required",
                min: (value) => {
                    return !value || value >= 0 || "Amount can't be negative";
                },
            },

            emailRules: [
                (value) => !!value || "Required.",
                (value) => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return pattern.test(value) || "Invalid e-mail.";
                },
            ],
        };
    },
    async created() {
        this.scheduleMode = "month";
    },
    watch: {
        tuitionBalance(newValue, oldValue) {
            const amount = newValue.replace(/[$,]/g, "");

            this.tuitionAmount = +amount > 0 ? +amount : 0;
        },
        transportationBalance(newValue, oldValue) {
            const amount = newValue.replace(/[$,]/g, "");

            this.transportationAmount = +amount > 0 ? +amount : 0;
        },
        paymentMethods(newValue, oldValue) {
            if (!newValue || !newValue.length) return;

            this.selectedCard = newValue[0].cardInfo;
        },
        account(newValue) {
            if (newValue.emailAddress) {
                this.emailAddress = newValue.emailAddress;
            }
        },
    },
    computed: {},
    methods: {
        getSchedulePayments() {
            return this.schedules.filter(
                (s) => this.isScheduledPayment(s.date) && +s.tuitionAmount > 0,
            );
        },
        confirmPayment() {
            if (!this.validate()) return;

            this.showConfirmView = true;
        },
        buildData() {
            return {};
        },
        isHebrew(char) {
            // Check if the character is a single character and within the Hebrew Unicode range.
            return (
                typeof char === "string" &&
                char.length === 1 &&
                /[\u0590-\u05FF]/.test(char)
            );
        },
        isNumber(str) {
            // Use a string method to avoid converting a number like `8` to a string.
            const input = String(str);

            // Use `parseFloat` to handle potential decimal numbers.
            // We use `isFinite` to exclude `Infinity` and `-Infinity`.
            // We check for `str.length > 0` to exclude empty strings.
            return (
                input.length > 0 && !isNaN(parseFloat(input)) && isFinite(input)
            );
        },
        dayInMonthChanged() {
            if (this.paymentMode != "schedule") return;
            if (!this.dayInMonth) return;

            if (this.calendarMode == "hebrew") {
                return this.createSchedulesBasedOnHebDate();
            } else {
                return this.createSchedulesBasedOnEngDate();
            }
        },
        async createSchedulesBasedOnHebDate() {
            try {
                let hDates = await this.$http.get(
                    "api/payments/GetHDates?from=" +
                        this.startDate +
                        "&months=" +
                        this.numberOfPayments,
                );

                this.schedules = [];

                const tuitionAmount =
                    this.tuitionAmount / this.numberOfPayments;

                const dayNumber = +this.calendarDays.find(
                    (c) => c.HEBREW == this.dayInMonth,
                ).value;

                const hebDate = new Hebcal.HDate(new Date());

                if (dayNumber < hebDate.day) {
                    //hDates = hDates.filter((h) => h.mmonth > hebDate.month);
                    hDates = hDates.filter(
                        (h) =>
                            !(
                                h.mmonth == hebDate.month &&
                                h.yyear == hebDate.year
                            ),
                    );
                }

                const scheduleHDates = hDates
                    .map((h) => h.mmonth)
                    .filter(onlyUnique)
                    .map((month) => {
                        let hDate = hDates.find(
                            (h) => h.mmonth == month && h.mday == dayNumber,
                        );

                        //month without 30 days
                        if (!hDate) {
                            return hDates.find(
                                (h) => h.mmonth == +month + 1 && h.mday == 1,
                            );
                        }

                        return hDate;
                    })
                    .filter(Boolean);

                scheduleHDates.forEach((scheduleHDate, index) => {
                    if (index + 1 > this.numberOfPayments) return;

                    this.createSchedule(
                        scheduleHDate.pardate,
                        scheduleHDate.hdesc,
                        +tuitionAmount.toFixed(2),
                    );
                });
            } catch (e) {
                console.log(e);
            }
        },
        createSchedulesBasedOnEngDate() {
            this.schedules = [];

            const tuitionAmount = this.tuitionAmount / this.numberOfPayments;

            let startDate = new Date(this.startDate + "T00:00:00");

            if (startDate.getDate() > this.dayInMonth) {
                startDate = new Date(moment(startDate).add(1, "months"));
            }

            for (var i = 0; i < this.numberOfPayments; i++) {
                const schedule = {
                    date: new Date().toISOString().substr(0, 10),
                    amount: 0,
                    datePickerMenu: false,
                };

                schedule.tuitionAmount = +tuitionAmount.toFixed(2);

                schedule.date = toISOLocal(
                    new Date(
                        startDate.getFullYear(),
                        startDate.getUTCMonth() + i,
                        this.dayInMonth,
                    ),
                ).substr(0, 10);

                this.schedules.push(schedule);
            }
        },
        calendarModeChanged(value) {
            if (value == "hebrew") {
                this.dayInMonth = "א";
            } else {
                this.dayInMonth = 1;
            }

            this.generateSchedules();
        },
        generateSchedules() {
            if (this.showCalendarDays) {
                return this.dayInMonthChanged();
            }

            this.schedules = [];

            if (this.paymentMode != "schedule") return;

            const tuitionAmount = this.tuitionAmount / this.numberOfPayments;

            for (var i = 0; i < this.numberOfPayments; i++) {
                const schedule = {
                    date: new Date().toISOString().substr(0, 10),
                    amount: 0,
                    datePickerMenu: false,
                };

                schedule.tuitionAmount = +tuitionAmount.toFixed(2);
                // schedule.transportationAmount = +transportationAmount.toFixed(
                //     2
                // );

                schedule.date = toISOLocal(
                    this.scheduleMode == "month"
                        ? new Date(moment(this.startDate).add(i, "months"))
                        : new Date(moment(this.startDate).add(i, "weeks")),
                ).substr(0, 10);

                this.schedules.push(schedule);
            }
        },
        createSchedule(date, hebrewDate, tuitionAmount) {
            const schedule = {
                date: toISOLocal(new Date(date)).substr(0, 10),
                amount: 0,
                datePickerMenu: false,
                tuitionAmount,
                hebrewDate,
            };

            this.schedules.push(schedule);
        },
        getCategoryCode(category) {
            var reverseMap = new Map();

            Array.from(this.categories.entries()).forEach(([value, key]) => {
                reverseMap.set(key, value);
            });

            return reverseMap.get(category)
                ? reverseMap.get(category)
                : category;
        },
        confirmScheduleCancellation() {
            this.confirmCancellationDialog = true;
        },
        formatDate(date) {
            return moment(date).format("L");
        },
        closeNewPaymentMethodDialog() {
            this.newPaymentMethodDialog = false;
        },
        updateSelectedPaymentMethod(paymentMethod) {
            paymentMethod.cardInfo =
                paymentMethod.cardType + " - " + paymentMethod.cardNumberLast5;

            this.paymentMethods.push(paymentMethod);

            this.selectedCard = paymentMethod.cardInfo;
        },
        getTuitionPaymentAmount() {
            return this.paymentMode == "single"
                ? +this.tuitionAmount
                : sum(
                      this.schedules
                          .filter((s) => this.isToday(s.date))
                          .map((s) => +s.tuitionAmount),
                  );
        },
        getTransportationPaymentAmount() {
            return this.paymentMode == "single"
                ? +this.transportationAmount
                : sum(
                      this.schedules
                          .filter((s) => this.isToday(s.date))
                          .map((s) => +s.transportationAmount),
                  );
        },
        getPaymentDetails() {
            const details = [];

            const tuitionAmount = +this.getTuitionPaymentAmount();

            const transportationAmount = +this.getTransportationPaymentAmount();

            if (tuitionAmount > 0) {
                details.push({
                    categoryCode: "TC",
                    amount: tuitionAmount,
                });
            }

            // if (transportationAmount > 0) {
            //     details.push({
            //         categoryCode: "TRNS",
            //         amount: transportationAmount,
            //     });
            // }

            return details;
        },
        validate() {
            const validations = [
                this.$refs.tuitionAmount.validate(true),
                this.$refs.emailAddress.validate(true),
            ];

            if (this.paymentMode == "schedule") {
                validations.push(this.$refs.numberOfPayments.validate(true));
            }

            return validations.every(Boolean);
        },
        getPaymentMethod(cardInfo) {
            return this.paymentMethods.find((p) => p.cardInfo == cardInfo).id;
        },
        isScheduledPayment(date) {
            return !this.isToday(date);
        },
        isToday(date) {
            return moment(date).isSame(new Date(), "day");
        },
        getCurrentAmount() {
            if (this.paymentMode == "single")
                return +this.tuitionAmount;

            return sum(
                this.schedules
                    .filter((s) => this.isToday(s.date))
                    .map((s) => +s.tuitionAmount),
            );
        },
        hasScheduledPayments() {
            return this.schedules
                .filter((s) => +s.tuitionAmount > 0)
                .some((s) => this.isScheduledPayment(s.date));
        },
        getPaymentConfirmationDetails() {
            return [
                {
                    category: "Tuition",
                    amount: formatCurrency(this.getTuitionPaymentAmount()),
                },
                // {
                //     category: "Transportation",
                //     amount: formatCurrency(
                //         this.getTransportationPaymentAmount()
                //     ),
                // },
            ];
        },
        getPaymentConfirmationHeaders() {
            return [
                {
                    text: "DEPARTMENT",
                    value: "category",
                    sortable: false,
                    align: "left",
                },
                {
                    text: "AMOUNT",
                    value: "amount",
                    align: "right",
                    sortable: false,
                },
            ];
        },
        getScheduleConfirmationHeaders() {
            return [
                {
                    text: "DATE",
                    value: "date",
                    align: "left",
                    sortable: false,
                },
                {
                    text: "TUITION",
                    align: "center",
                    value: "tuition",
                    sortable: false,
                },
                // {
                //     text: "TRANSPORTATION",
                //     value: "transportation",
                //     align: "right",
                //     sortable: false,
                // },
            ];
        },
        getScheduleConfirmationDetails() {
            return this.schedules
                .filter(
                    (s) =>
                        +s.tuitionAmount > 0 && this.isScheduledPayment(s.date),
                )
                .map((schedule) => {
                    return {
                        date: moment(schedule.date).format("L"),
                        tuition: formatCurrency(schedule.tuitionAmount),
                        // transportation: formatCurrency(
                        //     schedule.transportationAmount
                        // ),
                    };
                });
        },
        async process() {
            this.processing = true;

            if (this.getCurrentAmount()) {
                try {
                    this.processingMessage = "Processing Payment...";

                    await this.processPayment();

                    if (this.hasScheduledPayments()) {
                        this.processingMessage = "Processing Schedule...";

                        await this.processSchedule();
                    }

                    this.processing = false;
                    this.processingMessage = "";

                    //this.closeDialog();

                    //this.reloadPage();
                } catch (e) {
                    this.processing = false;
                    this.processingMessage = "";
                    this.paymentProcessed = true;
                    this.scheduleProcessed = true;
                }
            } else {
                try {
                    this.processingMessage = "Processing Schedule...";

                    await this.processSchedule();

                    this.processing = false;
                    this.processingMessage = "";

                    //this.closeDialog();

                    //this.reloadPage();
                } catch (e) {
                    this.processing = false;
                    this.processingMessage = "";
                    this.paymentProcessed = true;
                    this.scheduleProcessed = true;
                }
            }
        },
        async processPayment() {
            try {
                const response = await this.$http.post(
                    "api/payments/newPayment",
                    {
                        user: this.$store.state.authentication.user,
                        isTest: window.location.origin.startsWith(
                            "http://localhost",
                        ),
                        accountID: this.account.accountID,
                        emailAddress: this.emailAddress,
                        paymentMethodID: this.getPaymentMethod(
                            this.selectedCard,
                        ),
                        amount: this.getCurrentAmount(),
                        details: this.getPaymentDetails(),
                    },
                );

                this.paymentStatus = response.resultCode;
                this.paymentResult = response.transactionResult;
            } catch (e) {
                this.paymentStatus = "E";
                this.paymentResult = "An error has occurred";

                throw new Error("Payment Error");
            } finally {
                this.paymentProcessed = true;
            }

            // this.$notify({
            //     text: "Payment Successful",
            //     group: "notification",
            //     type: "success"
            // });
        },
        async processSchedule() {
            try {
                await this.$http.post("api/payments/newSchedule", {
                    user: this.$store.state.authentication.user,
                    isTest: window.location.origin.startsWith(
                        "http://localhost",
                    ),
                    dontAuthorize: this.dontAuthorize,
                    accountID: this.account.accountID,
                    emailAddress: this.emailAddress,
                    paymentMethodID: this.getPaymentMethod(this.selectedCard),
                    scheduleDetails: this.getScheduleDetails(),
                });
            } catch (e) {
                this.scheduleError = e.Message;

                throw new Error("Schedule Error");
            } finally {
                this.scheduleProcessed = true;
            }
        },
        getScheduleDetails() {
            return this.schedules
                .filter(
                    (s) =>
                        this.isScheduledPayment(s.date) &&
                        +s.tuitionAmount > 0,
                )
                .map((detail) => {
                    const details = [];

                    if (+detail.tuitionAmount > 0) {
                        details.push({
                            categoryCode: "TC",
                            amount: +detail.tuitionAmount,
                        });
                    }

                    // if (+detail.transportationAmount > 0) {
                    //     details.push({
                    //         categoryCode: "TRNS",
                    //         amount: +detail.transportationAmount,
                    //     });
                    // }

                    return {
                        date: moment(detail.date).format("YYYY-MM-DD HH:mm:ss"),
                        amount: +detail.tuitionAmount,
                        details: details,
                    };
                });
        },
        reset() {
            this.numberOfPayments = 1;
            this.paymentStatus = false;
            this.paymentResult = "";
            this.tuitionAmount = 0;
            this.transportationAmount = 0;
            this.schedules = [];
            this.note = "";
            this.paymentProcessed = false;
            this.scheduleProcessed = false;
            this.scheduleError = false;
            this.showConfirmView = false;
        },
    },
};
</script>
<style>
.big-button {
    padding: 0 10px !important;
    text-transform: uppercase;
    letter-spacing: 1px;
    font-size: 14px !important;
    /*background: #fff;*/
}
.big-button .v-btn__content {
    padding: 0 10px !important;
    line-height: 48px;
}

.button-toggle-override {
    border-radius: 5px;
    overflow: hidden;
    /*border-style: solid;*/
    /*border-color: #9e9e9e;
    border-width: 1px;*/
}

.button-toggle-override.v-btn-toggle .v-btn:not(:last-child) {
    border: none !important;
}

.button-toggle-override.v-btn-toggle .v-btn.v-btn--active {
    /*background-color: #e0e0e0;*/
    /* color: #fff;*/
    font-weight: 500 !important;

    background-color: #4caf50 !important;
    color: #fff;
}

.button-toggle-override.theme--light.v-btn-toggle .v-btn {
    background-color: #a8e8a4;
    opacity: 1;
    color: #fff;
    font-weight: 500 !important;
}

.v-card .v-divider {
    margin-left: unset !important;
    margin-right: unset !important;
}

</style>
